import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { FinancialUtils } from '@macs-frontend/features/shared';

@Pipe({
  name: 'distanceFormat',
  pure: true,
})
export class DistanceFormatPipe implements PipeTransform {
  @memoize()
  transform(distance?: number | null): string {
    if (!distance) {
      return '??';
    }

    if (distance < 1000) {
      return `${Math.round(distance)} m`;
    }

    const distanceInKm = Math.round(distance / 1000);

    return `${distanceInKm} km`;
  }
}
